export default function supportsLocalStorage() {
  const key = 'localstorage';

  try {
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./utils/supportsLocalStorage.js